import Vue from "vue"
import Router from "vue-router"
import { getCookie } from '@/utils'
import { Message } from "element-ui"

Vue.use(Router)

export const fixedRoutes = [
  {
    //进入页
    path: "/:flag/entry",
    name: "Entry",
    component: () => import("@/views/Entry")
  },
  {
    //练习首页
    path: "/:flag/mockExam",
    name: "MockExam",
    component: () => import("@/views/MockExam"),
    redirect: "/:flag/mockExam/examSystem",
    children: [
      {
        path: "examSystem",
        name: "examSystem",
        meta: { title: "考试系统" },
        component: () => import("@/views/MockExam/examSystem")
      },
      {
        path: "examRecord",
        name: "examRecord",
        meta: { title: "考试记录" },
        component: () => import("@/views/MockExam/examRecord")
      },
      {
        path: "examChapter",
        name: "examChapter",
        meta: { title: "按章练习" },
        component: () => import("@/views/MockExam/examChapter")
      },
      {
        path: "chapterRecord",
        name: "chapterRecord",
        meta: { title: "练习记录" },
        component: () => import("@/views/MockExam/chapterRecord")
      },
      {
        path: "mistakeRecord",
        name: "mistakeRecord",
        meta: { title: "错题记录" },
        component: () => import("@/views/MockExam/mistakeRecord")
      }
    ]
  },
  {
    //考试说明步骤
    path: '/:flag/realMockExam',
    name: 'RealMockExam',
    component: () => import("@/views/RealMockExam"),
    redirect: '/:flag/realMockExam/step1',
    children: [
      {
        path: 'step1',
        name: 'Step1',
        component: () => import('@/views/RealMockExam/step1')
      },
      {
        path: 'step2',
        name: 'Step2',
        component: () => import('@/views/RealMockExam/step2')
      }
    ]
  },
  {
    //开始考试
    path: '/:flag/doExam',
    name: 'DoExam',
    component: () => import('@/views/DoExam/index')
  },
  {
    path: '/:flag/analysis',
    name: 'analysis',
    meta: { title: '答案解析' },
    component: () => import('@/views/Analysis/index')
  },
  {
    path: '/:flag/mistakeRedo',
    name: 'mistakeRedo',
    meta: { title: '错题记录重做' },
    component: () => import('@/views/Analysis/mistakeRedo')
  },
  {
    //普通卷
    path:'/ordinaryExam',
    name:'OrdinaryExam',
    component: () => import('@/views/OrdinaryExam')
  },
  {
    //开始按章练习
    path: '/:flag/doExamChapter',
    name: 'doExamChapter',
    component: () => import('@/views/DoExamChapter')
  }
]


const createRouter = () => new Router({
  base: "/",
  routes: fixedRoutes
})

const router = createRouter()

//设置路由导航守卫
router.beforeEach((to, from, next) => {
  // to要去的页面 from从哪里来 next放行
  const userID = getCookie('cdeluid') ? Number(getCookie('cdeluid')) : null
  if (userID) {
    next()
  } else {
    //弹窗登录
    // window.CDEL.ucLogin()
    window.loginRegister(1)
  }
})

export default router
